import { render, staticRenderFns } from "./SecondColumn.vue?vue&type=template&id=d4938424"
import script from "./SecondColumn.vue?vue&type=script&lang=js"
export * from "./SecondColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports